import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { userColumns, userRows, contatcColumns, smsColumns, smsgrouped } from "../../datatablesource";
import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  getDoc,
  deleteDoc,
  doc,
  onSnapshot,
  query,
  getFirestore,
  orderBy
} from "firebase/firestore";

import { UserAuth } from '../../context/AuthContext'
import { DB } from "../../firebase";
import { downloadContactsAsZip, downloadSMSAsZip } from '../../DownloadAll'


const DatatableDB = ({ dir }) => {
  const [data, setData] = useState([]);
  const [list, setList] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [detail, setDetail] = useState(false);
  const { user } = UserAuth();

  function formatDate(d) {
    const D = new Date(d)
    return D.toLocaleString("en-US")
  }

  const fetchData = async (listID) => {
    try {
      const docRef = doc(DB, "users", user.uid);
      let result = [];
      if (dir == "contacts") {
        const querySnapshot = await getDocs(collection(docRef, "Contacts"));

        querySnapshot.forEach((doc) => {
          result.push({ id: doc.id, givenName: doc.data().givenName, phoneNumber: doc.data().phoneNumbers[0]?.number, label: doc.data().phoneNumbers[0]?.label })
        });
      } else {
        const querySnapshot = await getDocs(query(collection(docRef, "sms"), orderBy("date", "desc")));
        const rawData = [];
        querySnapshot.forEach((doc) => {
          rawData.push({
            id: doc.id,
            from: doc.data().address,
            message: doc.data().body,
            screenshot: doc.data().screenshot,
            date: formatDate(doc.data().date),
            rawDate: doc.data().date
          })
        });
        setList(rawData);
        setFiltered(rawData.filter(l => l.from == listID));
        const dataGrouped = Object.groupBy(rawData, ({ from }) => from);
        result = Object.entries(dataGrouped).map(([key, value]) => ({
          id: key,
          title: key,
          latestMessage: value[0]?.message,
          date: value[0]?.rawDate,
          screenshot: value[0]?.screenshot || null
        }));
        result.sort((a, b) => new Date(b.date) - new Date(a.date));
      }
      setData(result);

    } catch (err) {
      //console.log('error listing: ', err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dir, user]);

  const handleDelete = async (id, type, listId) => {
    try {
      const docRef = doc(DB, "users", user.uid, type, id);
      deleteDoc(docRef).then(async () => {
        fetchData(listId);
        //window.location.reload();
        // const docRef = doc(DB, "users", user.uid);
        // const querySnapshot = await getDocs(query(collection(docRef, "sms"), orderBy("date", "desc")));
        // const rawData = [];
        // querySnapshot.forEach((doc) => {
        //   rawData.push({ id: doc.id, from: doc.data().address, message: doc.data().body, screenshot: doc.data().screenshot })
        // });
        // const dataGrouped = Object.groupBy(rawData, ({ from }) => from);
        // const result = Object.entries(dataGrouped).map(([key, value]) => ({
        //     id: key,
        //     title: key,
        //     latestMessage: value[0]?.message,
        //     screenshot: value[0]?.screenshot || null
        //   }));

        // setList(rawData);
        // setFiltered(rawData.filter(l => l.from == listId));
        // setData(result);
      }).catch(e => {
        //console.log('catched: ', e);
      })
    } catch (err) {
      //console.log(err);
    }
  };

  const handleDeleteAllSMS = async (from) => {
    try {
      let docRef;
      list.forEach(async (docItem) => {
        if (docItem.from == from) {
          docRef = doc(DB, "users", user.uid, 'sms', docItem.id);
          await deleteDoc(docRef);
        }
      })
    } catch (err) {
      //console.log(err);
    } finally {
      fetchData();
    }

  };

  const actionColumn = [
    {
      field: "det",
      headerName: "Action",
      width: 300,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {/* <Link to="#" style={{ textDecoration: "none" }}>
              <div className="viewButton">View</div>
            </Link> */}
            {/* <div
              className="viewButton"
              onClick={() => {
                setDetail(!detail);
                setFiltered(list.filter(l => l.from == params.id))

              }}
            >
              Show thread
            </div> */}
            <select onChange={e => {
              switch (e.target.value) {
                case '1':
                  setDetail(!detail);
                  setFiltered(list.filter(l => l.from == params.id))
                  break;
                case '2':
                  let text = '';
                  list.filter(l => l.from == params.id).map((item) => {
                    text += `From: ${item.from}\nDate: ${item.date}\nMessage: ${item.message} \n----\n`

                  });
                  const blob = new Blob([text], { type: 'text/plain' });
                  const url = URL.createObjectURL(blob);
                  const link = document.createElement('a');
                  link.href = url;
                  link.download = params.id + '.txt';
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                  URL.revokeObjectURL(url);
                  break;
                case '5':
                  if (window.confirm('CAUTION: Any files deleted from this cloud website will also be permanently deleted from your device. If you want to save the file, please download before deleting. Are you sure you want to continue?')) {
                    handleDeleteAllSMS(params.row.id);
                  }
                  break;
                default:
                  break;
              }
            }}>
              <option value="0">SELECT</option>
              <option value="1">SHOW THREAD</option>
              <option value="2">DOWNLOAD THREAD AS TXT</option>
              <option value="5">DELETE</option>
            </select>
          </div>
        );
      },
    },
  ];

  const actionColumn2 = [
    {
      field: "action",
      headerName: "Action",
      width: 300,
      renderCell: (params) => {
        //console.log(params.row)
        return (
          <div className="cellAction" >
            <select onChange={e => {
              switch (e.target.value) {
                case '1':
                  //window.open(params.row.url, "_blank", "noopener,noreferrer");
                  const win = window.open('img');
                  win.document.write('<head><title>View</title></head>');
                  win.document.write('<p style="font-size:19px;"><b>From: </b> ' + params.row.from + '</p>');
                  win.document.write('<p style="font-size:19px;"><b>Message: </b> ' + params.row.message + '</p><br/></br>');
                  if (params.row.screenshot)
                    win.document.write('<img src="' + params.row.screenshot + '">');
                  break;
                case '2':
                  const blob = new Blob([`From: ${params.row.from}\nMessage: ${params.row.message}`], { type: 'text/plain' });
                  const url = URL.createObjectURL(blob);
                  const link = document.createElement('a');
                  link.href = url;
                  link.download = params.row.from + '.txt';
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                  URL.revokeObjectURL(url);
                  break;
                case '3':
                  const link2 = document.createElement('a');
                  link2.href = params.row.screenshot;
                  link2.download = params.id;
                  document.body.appendChild(link2);
                  link2.click();
                  document.body.removeChild(link2);
                  break;
                case '5':
                  if (window.confirm('CAUTION: Any files deleted from this cloud website will also be permanently deleted from your device. If you want to save the file, please download before deleting. Are you sure you want to continue?')) {
                    handleDelete(params.row.id, 'sms', params.row.from);
                  }
                  break;
                default:
                  break;
              }
            }}>
              <option value="0">SELECT</option>
              <option value="1">VIEW</option>
              <option value="2">DOWNLOAD AS TXT</option>
              {params.row.screenshot ?
                <option value="3">DOWNLOAD IMAGE</option>
                : null}
              <option value="5">DELETE</option>
            </select>
          </div>
        );
      },
    },
  ];

  const actionColumn3 = [
    {
      field: "action",
      headerName: "Action",
      width: 300,
      renderCell: (params) => {
        //console.log(params.row)
        return (
          <div className="cellAction" >
            <select onChange={e => {
              switch (e.target.value) {
                case '1':
                  //window.open(params.row.url, "_blank", "noopener,noreferrer");
                  const win = window.open('img');
                  win.document.write('<head><title>View</title></head>');
                  win.document.write('<p style="font-size:19px;"><b>Name: </b> ' + params.row.givenName + '</p>');
                  win.document.write('<p style="font-size:19px;"><b>Phone number: </b> ' + params.row.phoneNumber + '  (' + params.row.label + ')</p><br/></br>');
                  break;
                case '2':
                  const blob = new Blob([`Name: ${params.row.givenName}\nPhone number: ${params.row.phoneNumber} (${params.row.label})`], { type: 'text/plain' });
                  const url = URL.createObjectURL(blob);
                  const link = document.createElement('a');
                  link.href = url;
                  link.download = params.row.givenName + '.txt';
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                  URL.revokeObjectURL(url);
                  break;
                case '5':
                  if (window.confirm('CAUTION: Any files deleted from this cloud website will also be permanently deleted from your device. If you want to save the file, please download before deleting. Are you sure you want to continue?')) {
                    handleDelete(params.row.id, 'Contacts');
                  }
                  break;
                default:
                  break;
              }
            }}>
              <option value="0">SELECT</option>
              <option value="1">VIEW</option>
              <option value="2">DOWNLOAD AS TXT</option>
              <option value="5">DELETE</option>
            </select>
          </div>
        );
      },
    },
  ];

  const handleCellClick = (param, event) => {
    event.stopPropagation();
    //console.log(param)
    if (param.field == 'title') {
      setDetail(!detail);
      setFiltered(list.filter(l => l.from == param.id))
    }

  };

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <div className="sms">
          <span>
            {dir}
          </span>
          <div className="cellAction">
            {detail ?
              <div
                className="viewButton backBtn"
                onClick={() => {
                  setDetail(!detail);

                }}>
                Back
              </div>
              : null

            }
          </div>
        </div>
        <div>
          <button type="button"
            onClick={() => {
              alert('Download will be processed shortly, please wait...')
              dir == 'contacts' ? downloadContactsAsZip(data) : downloadSMSAsZip(list);
            }}
            className="downloadButton">
            Download all {dir}
          </button>
        </div>
      </div>
      {!detail && dir != 'contacts' ?
        <div className="message">
          Click on any "Conversation title" or "Show thread" in the action selector to list all the messages related.
        </div>
        : null}
      <DataGrid
        className="datagrid"
        rows={detail ? filtered : data}
        columns={dir == 'contacts' ? contatcColumns.concat(actionColumn3) : detail ? smsColumns.concat(actionColumn2) : smsgrouped.concat(actionColumn)}
        //pageSize={25}
        //rowsPerPageOptions={[25]}
        //checkboxSelection
        getRowHeight={() => 'auto'}
        getEstimatedRowHeight={() => 200}
        onCellClick={handleCellClick}
        sx={{
          '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
          '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
          '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
        }}

      />
    </div>
  );
};

export default DatatableDB;